module.exports = __webpack_public_path__ + "assets/ecd67000a3be979a3ce517dd9ffc030e.png";